import React from "react";
import { Button, Typography, Container, Box } from "@mui/material";

const Result = () => {
    const handleDownload = async () => {
        try {
            const response = await fetch(`/api/test/downloadResult`, {
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error('Failed to download the file.');
            }

            // Convert the response to a Blob (binary data)
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            // Create a temporary anchor element to trigger the download
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Student_Results.xlsx'; // File name for the download
            a.click();

            // Clean up the object URL
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading the file:', error);
            alert('An error occurred while downloading the file.');
        }
    };

    return (
        <div className="p-4 background-radial-gradient overflow-hidden" style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
            <Container maxWidth="md">
                <>
                    <Box className="TopHere">
                        <div>
                            <img src="/bntLogo.png" alt="Logo" className='logo2' />
                        </div>
                        <div className="testPageStartsHere">
                            <Typography variant="h3" component="h1" color="white" gutterBottom>
                                Download
                            </Typography>
                            <Button variant="contained" color="primary" size="large" onClick={handleDownload}>
                                Download the result
                            </Button>
                        </div>
                    </Box>
                </>
            </Container>
        </div>
    );
};

export default Result;
